import {
  fontFamilyMagenos,
  fontFamilyRoboto,
  anthracite,
  iPacRed
} from '@components/hoc/Theme/Theme.styled';
import { isIpac } from '@config/constants';
import styled from 'styled-components';
import {Swiper, SwiperSlide} from "swiper/react";

export const FullPageLayout = styled.div`
  display: flex;
  width: 100%;
  @media (max-width: 1024px) {
    flex-direction: column;
  }
  height: 100dvh;
`;

export const FullWidthDiv = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const LeftColumnLayoutDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

export const LogoHorizontalDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  @media (max-width: 1024px) {
    padding: 12px;
  }
`;
export const PresentationIntro = styled.div`
  color: ${anthracite};
  font-size: 14px;
  display: flex;
  gap: 10px;
  align-items: center;
  &:not(:last-child) {
    margin-bottom: 20px;
  }

  svg {
    width: 30px;
  }
  p {
    margin: 0;
    flex: 1;
    font-size: 16px;
    line-height: 1.4;

    span {
      font-weight: 900;
    }
  }
`;

export const PresentationBlock = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 33.33%;
  padding: 20px 60px;
  background-size: 100% 100%;
  background-position: 0 0;
  background-image: radial-gradient(75% 75% at -22% 0%, ${ isIpac ? '#FFB1A1' : '#01DC98' } 0%, ${ isIpac ? '#FFF0D9' : '#C1F6F0' } 100%);

  @media (max-width: 1024px) {
    margin-top: 2rem;
    width: 100%;
    padding: 20px !important;
  }

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
`;

export const PresentationIntroBlock = styled.div`
    padding: 15px 20px;
    border-radius: 10px;
    background: #FFF;
    z-index: 2;
`;

export const SwiperStyled = styled(Swiper)`
  --swiper-pagination-bullet-inactive-color: #004C3C;
  --swiper-pagination-color: ${ isIpac ? iPacRed : '#006FFF' };
  --swiper-pagination-bullet-inactive-opacity: 1;
  --swiper-pagination-bullet-size: 14px;
  width: 100%;

  .swiper-pagination {
    padding-top: 10px;
    top: 0;
    position: relative;
  }
  .swiper-wrapper {
    align-items: center;
  }
`

export const SwiperSlideStyled = styled(SwiperSlide)`
  display: flex;
  flex-direction: column;
  gap: 5px;
  > div {
    padding: 15px 20px;
    border-radius: 10px;
    background: #FFF;
    > p:first-child {
      font-family: ${fontFamilyMagenos};
      font-weight: 900;
    }
  }
`

export const ReassuranceText = styled.p`
  font-family: ${fontFamilyMagenos};
  font-size: 18px;
  font-weight: 900;
`

export const AvisVerifiesSwiperContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-around;
  span {
    margin: auto 8px;
    color: ${ isIpac ? '#004c3c' : '#006FFF' };
    font-size: 15px;
  }

  p {
    color: ${ isIpac ? iPacRed : '#006FFF' };
    text-align: center;
    font-size: 12px !important;
    font-family: ${fontFamilyRoboto};
  }
  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

export const AvisVerifiesContainer = styled.div`
  margin-top: 3rem;
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: center;
  padding: 10px;
  align-items: center;
  border-radius: 10px;
  background: #FFF;
  z-index: 2;
  span {
    font-size: 12px;

    &:first-child {
      color: ${ isIpac ? iPacRed : '#006FFF' };
    }
    &:nth-child(2) {
      font-weight: 900;
    }
  }
  @media (max-width: 1024px) {
    justify-content: center;
    margin-top: 0;
  }
`;

export const FormBlock = styled.div`
  flex-grow: 1;
  width: 66.67%;
  display: flex;
  flex-direction: column;
  @media (max-width: 1024px) {
    order: -1;
    width: 100%;
  }
  @media (min-width: 1024px) {
    overflow-y: scroll;
  }
  background-color: #f8fcfd !important;
`;


export const FooterCopyright = styled.div`
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 8px 8px 8px;
  @media (max-width: 1024px) {
    display: none;
  }
`;
